<div [attr.inert]="isOffline ? '' : null" [attr.aria-hidden]="isOffline ? 'true' : null" [hidden]="isOffline">
<a class="skip-link" href="#streakers-content">Skip to content</a>
<header class="streakers-header">
  <a routerLink="/" class="streakers-brand" aria-label="Holiday Streakers home"><img src="/assets/img/streakers/logo-white.png" alt="Holiday Streakers"></a>
  <streakers-navigation></streakers-navigation>
  <div class="streakers-account">
    <dw-dynamic-loader [component]="components.autoUpdateCheckerComponent"></dw-dynamic-loader>
    <span *ngIf="environmentMessage" class="environment-badge">{{ environmentMessage }}</span>
    <div class="account-controls"><dw-dynamic-loader [component]="components.securityInfoComponent"></dw-dynamic-loader></div>
  </div>
</header>
<div class="streakers-status"><dw-message-bar showToasts="true" showRequestCounts="true"></dw-message-bar></div>
<main id="streakers-content" class="streakers-main" tabindex="-1">
  <dw-dynamic-loader *ngIf="showLoginProcess && !isOffline" [component]="components.securityMessageComponent"
    (configure)="configureSecurityMessageComponent($event)"></dw-dynamic-loader>
  <div [hidden]="!logoutMessage"><dw-message [(message)]="logoutMessage"></dw-message></div>
  <section *ngIf="showRouterFinal" class="streakers-page"><router-outlet></router-outlet></section>
</main>
<app-aside [fixed]="true" [display]="false" class="streakers-configuration" id="streakers-configuration"
  [class.configuration-open]="configurationPanel.isExpanded" [attr.aria-hidden]="!configurationPanel.isExpanded"
  [attr.inert]="configurationPanel.isExpanded ? null : ''">
  <button *ngIf="configurationPanel.isExpanded" class="configuration-close" type="button"
    (click)="configurationPanel.toggleSidebar('config', true)" aria-label="Close configuration panel">×</button>
  <dw-ui-config-panel #configurationPanel></dw-ui-config-panel>
</app-aside>
<dw-modal-host *ngIf="showModalHost"></dw-modal-host>
</div>
<section *ngIf="showOfflineFinal"><dw-dynamic-loader [component]="components.offlineComponent"></dw-dynamic-loader></section>

